import { createStyles, makeStyles } from '@material-ui/styles'
import colors from 'shared/style/colors'

export const useStyles = makeStyles(() =>
  createStyles({
    nav: {
      '@media print': {
        display: 'none'
      },
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: 20,
      backgroundColor: colors.white,
      lineHeight: '5rem'
    },
    separator: {
      margin: '0 auto',
      width: '98%',
      height: '2px',
      backgroundColor: colors.background
    },
    mobileSeparator: {
      margin: '4rem auto 0 auto'
    }
  })
)
